import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { catchError, EMPTY, Observable } from 'rxjs';
import { AnnouncementsApi } from '../../../../shared/services/api/announcements.api';
import { AnnouncementDetails } from '../../../../shared/models/announcement-details';
import { HttpResponseService } from '../../../../core/services/http-error-response.service';

export const announcementEditResolver: ResolveFn<AnnouncementDetails> = (
  route,
): Observable<AnnouncementDetails> => {
  const api = inject(AnnouncementsApi);
  const httpResponseService = inject(HttpResponseService);
  const idParam = route.paramMap.get('id');
  const parsedId = idParam ? Number(idParam) : NaN;

  if (!Number.isFinite(parsedId)) {
    throw new Error('Invalid announcement id.');
  }

  return api.getAnnouncementDetails$(parsedId).pipe(
    catchError((err) => {
      httpResponseService.showErrorMessage(
        err,
        'Wystąpił błąd podczas pobierania komunikatu.',
      );
      return EMPTY;
    }),
  );
};
